import { Button } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../../RoutesWithAuth';
import axios from '../../../../common/AxiosConfig';
import { makeStyles } from '@mui/styles';
import Arrow from './Arrow';
import Tabs from './PrivacyTaskTabs';

const getDisplayValue = (value) => value || null;

const useStyles = makeStyles(() => ({
    backButton: {
        padding: 0,
        border: 'none',
        background: 'transparent',
        color: 'black',
        cursor: 'pointer',
        font: 'inherit',
        textTransform: 'initial'
        //textDecoration: 'underline'
    },
    taskSummary: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10px',
        fontWeight: '600',
        fontSize: '14px',
        padding: '13px 0px 5px 0px'
    },
    taskSummaryFirstItem: {
        paddingRight: '20px',
        paddingLeft: '50px'
    },
    taskSummaryItem: {
        paddingRight: '20px'
    },
    detailsWrapper: {
        border: '1px solid #C4D2E2',
        padding: '4px',
        width: '82vw',
        marginRight: '10px'
    },
    workflowOverviewLabel: {
        marginLeft: '6.5px'
    }
}));

const PrivacyTaskDetails = ({ task, onBack }) => {
    const classes = useStyles();
    const context = useContext(AppContext);
    const authToken = context.authToken.get;
    const [taskDetails, setTaskDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchTaskDetails = () => {
        if (!task?.task_id) return;

        setIsLoading(true);
        setError('');
        axios.get(`centra/privacy-task/${encodeURIComponent(task.task_id)}`, {
            headers: {
                Authorization: authToken
            }
        }).then((res) => {
            setTaskDetails(res.data || null);
        }).catch((err) => {
            setTaskDetails(null);
            setError(err?.response?.data?.message || err?.message || 'Unable to load privacy task details.');
        }).finally(() => {
            setIsLoading(false);
        });
    };

    useEffect(() => {
        fetchTaskDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, task?.task_id]);

    const detailTask = taskDetails?.task || task || {};
    const taskInformation = taskDetails?.task_information?.result || [];
    const taskUpdateRows = taskDetails?.task_update?.rows || [];

    return (
        <div>
            {onBack && (
                <Button className={classes.backButton} variant="outlined" size="small" onClick={onBack}>
                    &gt; Privacy Tasks Summary
                </Button>
            )}
            {error && <div>{error}</div>}
            <div className={classes.taskSummary}>
                <div className={classes.taskSummaryFirstItem}>Task ID: {getDisplayValue(detailTask.task_id)}</div>
                <div className={classes.taskSummaryItem}>Task Title: {getDisplayValue(detailTask.title)}</div>
                <div className={classes.taskSummaryItem}>Assigned To: {getDisplayValue(detailTask.assigned_to || detailTask.task_owner_name)}</div>
                <div>Status: {getDisplayValue(detailTask.status)}</div>
            </div>
            <div className={classes.workflowOverviewLabel}>
                <h6>Workflow Overview</h6>
            </div>
            <Arrow activeStage={detailTask.workflow_stage} />
            <br />
            <div className={classes.detailsWrapper}>
                <div>
                    <Tabs
                        taskInformation={taskInformation}
                        taskUpdateRows={taskUpdateRows}
                        taskId={detailTask.task_id}
                        onUpdateSuccess={fetchTaskDetails}
                    />
                </div>
            </div>
        </div>
    );
};

export default PrivacyTaskDetails;